import React from 'react'
import PropTypes from 'prop-types'

import defaultStyles from './productBlockSticker.css'

const ProductBlockSticker = ({ text, title, styles }) => {
  if (!(title || text)) {
    return null
  }

  const myStyles = styles || defaultStyles

  return (
    <div className={myStyles.stickerTag}>
      {title && <div className={myStyles.stickerTitle}>{title}</div>}
      {text &&
      <div
        className={myStyles.stickerText}
        dangerouslySetInnerHTML={{ __html: text }} // eslint-disable-line react/no-danger
      />
      }
    </div>
  )
}

ProductBlockSticker.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  styles: PropTypes.object
}

ProductBlockSticker.defaultProps = {
  title: '',
  text: '',
  styles: null
}

export default ProductBlockSticker
